import React from "react";
import { Card, Col, Row, Button, ListGroup } from "react-bootstrap";
import { Event, User } from "../types/Types";
import EventCard from "./EventCard";

interface EventsCardProps {
  title: string;
  events: Event[];
  currentUser: User;
  onEventClick: (event: Event) => void;
  onNewEvent?: () => void;
  emptyMessage: string;
}

const EventsCard: React.FC<EventsCardProps> = ({
  title,
  events,
  currentUser,
  onEventClick,
  onNewEvent,
  emptyMessage
}) => {
  return (
    <Card className="mb-3">
      <Card.Header className="">
        <Row>
          <Col>
            <h5>{title}</h5>
          </Col>
          {onNewEvent && (
            <Col xs="auto">
              <Button variant="primary" size="sm" onClick={onNewEvent}>
                Create Event
              </Button>
            </Col>
          )}
        </Row>
      </Card.Header>
      <Card.Body style={{ padding: '0.75rem' }}>
        {events.length === 0 ? (
          <p className="text-muted">{emptyMessage}</p>
        ) : (
          <ListGroup variant="flush" style={{ paddingBottom: '0' }}>
            {events.map((event, index) => (
              <EventCard 
                key={event.id}
                event={event}
                onClick={() => onEventClick(event)}
                showDescription={true}
                isLastItem={index === events.length - 1}
                clickable={currentUser.admin}
                currentUser={currentUser}
              />
            ))}
          </ListGroup>
        )}
      </Card.Body>
    </Card>
  );
};

export default EventsCard;
